module.exports = function(service) {
	'use strict'
	service.factory('refreshtokenService',refreshtokenService);
	refreshtokenService.$inject=['$rootScope','$timeout','$state','$window','authtokenService','alertService', 'serverError','postDataService'];
	function refreshtokenService($rootScope, $timeout, $state, $window, authtokenService,alertService, serverError,postDataService) {
		var refreshToken = {
			getAccessToken : function() {
				var status;
				var userId = parseInt(authtokenService.getUserId());
				 return postDataService.save({param1:'auth', param2: 'renewToken'},{'user_id': parseInt(userId)}).$promise.then(function(data){
					authtokenService.setToken(data.access_token);
				 	status = 200;
				 	return status;
				},function(error) {
					if(error.status ==401) {
						$rootScope.isLogout = true;
						authtokenService.removeToken();
						$rootScope.alerts = [];
						$rootScope.alertShow = false;
						$state.go('login');
						status = 401;
					} else if(error.status ==502) {
						// if(!$rootScope.errorServerFlag) {
							serverError();
						// }
						// $rootScope.errorServerFlag = true;
						status = 502;
					}
					return status
				});		
				
			}
		}
		return refreshToken;
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/refreshtokenService.js
// module id = 622
// module chunks = 0